import React from "react";
import clsx from "clsx";
import { Pencil, MousePointer2, RotateCcw, Trash2 } from "lucide-react";

const TOOLS = [
  { id: "draw", label: "Draw Area", icon: Pencil },
  { id: "edit", label: "Edit", icon: MousePointer2 },
  { id: "delete", label: "Delete", icon: Trash2 },
  { id: "reset", label: "Reset Tools", icon: RotateCcw },
];

const DrawToolbar = ({
  activeTool,
  setActiveTool,
  onDeleteClick,
  onResetClick,
}) => {
  return (
    <div className='bg-white rounded-xl shadow-md flex items-center p-1.5 gap-0.5 w-fit'>
      {TOOLS.map((tool) => {
        const Icon = tool.icon;
        const active = activeTool === tool.id;
        return (
          <button
            key={tool.id}
            type='button'
            title={tool.label}
            aria-label={tool.label}
            onClick={() => {
              if (tool.id === "reset" && onResetClick) {
                onResetClick();
                return;
              }
              if (tool.id === "delete" && onDeleteClick) {
                onDeleteClick();
                return;
              }
              setActiveTool(active ? null : tool.id);
            }}
            className={clsx(
              "w-9 h-9 rounded-lg flex items-center justify-center transition-colors",
              active
                ? "bg-primaryGreen text-white"
                : "text-HeaderColor hover:bg-bgGreen",
            )}
          >
            <Icon size={17} />
          </button>
        );
      })}
    </div>
  );
};

export default DrawToolbar;
